<template>
  <div class="row">
      <div class="col-sm-12">
          <div class="ibox">
              <div class="ibox-title">
                  <el-form  id="elForm"  :inline="true" :model="queryForm" ref="queryForm" label-width="85px" label-position="right" class="demo-form-inline" size="medium">
                  
                      <el-form-item label="测试日期：" >
                          <el-date-picker v-model="queryForm.testDate" type="daterange" value-format="yyyy-MM-dd"
                           align="right" @change="changePhy" placeholder="选择日期范围" :picker-options="pickerOptions" ></el-date-picker>
                      </el-form-item>

                      <el-form-item label="评定标准：">
                        <el-select v-model="queryForm.specId" placeholder="请选择评定标准">
                          <el-option v-for="item in standList" :key="item.id" :label="item.standardName" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    
                      <el-form-item label="姓名：">
                          <el-input v-model="queryForm.childName" placeholder="请输入姓名" style="width:205px" clearable></el-input>
                      </el-form-item>

                      <el-form-item>
                          <el-button class="btn-primary" @click="getList">查询</el-button>
                          <el-button class="btn-default" @click="onReset">重置</el-button>
                      </el-form-item>
                  </el-form>
                  <div class="mb15">
                    <!-- <el-button @click="addPhysique"><i class="el-icon-edit"></i>&nbsp;添加</el-button>
                    <el-button @click="remove"><i class="el-icon-delete"></i>&nbsp;删除</el-button> -->
                    <el-button v-for='(item,index) in generalArea' :key='index' class="btn-outline" @click="doClick(item.operFunc)"  plain>{{item.operName}}</el-button>
                  </div>
                   <el-table :data="tableData" border class="stuList" v-loading="tableLoading" element-loading-text="拼命加载中" @select="tableSelect" @select-all="tableSelectAll">
                      <el-table-column type="selection" width="55"></el-table-column>
                      <template v-for="(item, iidx) in thData">
                        <!-- <el-table-column v-if="item.show && (item.prop==='batchName')" width="100" :key="iidx" :prop="item.prop" :label="item.label"></el-table-column>
                        <el-table-column v-else-if="item.show" :key="iidx" :prop="item.prop" :label="item.label"></el-table-column> -->
                        <el-table-column :key="iidx" :prop="item.prop" :label="item.label"></el-table-column>
                      </template>
                      <el-table-column label="操作" width="160">
                        <template slot-scope="scope">
                          <el-button @click="operate(scope.row)" type="text" size="small">修改</el-button>
                          <el-button @click="remove(scope.row)" type="text" size="small">删除</el-button>
                          <el-button @click="detail(scope.row)" type="text" size="small">详情</el-button>
                          <!-- <el-button v-for='(item,index) in listArea' :key='index' class="btn-outline" @click="doClick(item.operFunc,scope.$index,scope.row)" size="small" type="text">{{item.operName}}</el-button> -->
                          <!-- <el-button @click="showPhyList(scope.row)" :disabled="!scope.row.dataResult" type="text" size="small">体质分析报告</el-button> -->
                        </template>
                      </el-table-column>
                    </el-table>
                  <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page.sync="queryForm.pageNum"
                  :page-sizes="[10, 25, 50, 100]"
                  :page-size="queryForm.pageSize"
                  layout="total,sizes,prev,pager,next,jumper"
                  :total="total" style="margin-top: 10px;">
                  </el-pagination>
              </div>
          </div>
      </div>
      <!--彈出的添加-->
    <el-dialog title="" :visible.sync="dialogVisable" width="900px" min-width="500px" :before-close="handleClose" :close-on-click-modal='false'>
      <router-view v-on:close="close" v-if="dialogVisable"></router-view>
    </el-dialog>
</div>
</template>
<script>
import { MessageBox, Loading} from 'element-ui'
import ajax from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件
import common from '../../com/common'

export default {
  name: '',
  data () {
    
    return {
      total:0,
      // ok~~~~~~~~~~~~~~~
      queryForm:{
        testDate:'',
        specId:'',// 评定标准
        childName:'',//儿童姓名
        pageNum:1,
        pageSize:10
      },
      thData:[],//表头数据
      tableData: [], // 数据表数据
      standList:[],
      pickerOptions: {
        shortcuts: [ {
          text: '过去七天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '过去30天',
          onClick (picker) {
            const end = new Date()
            const start = that.GetMonthStr(1)
          //   start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '过去半年',
          onClick (picker) {
            const end = new Date()
            const start = that.GetMonthStr(6)
          //   start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '过去一年',
          onClick (picker) {
            const end = new Date()
            const start = that.GetMonthStr(12)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      generalArea:[],
      dialogVisable: false,// 是否为编辑，用于显示隐藏编辑窗口
      // ok~~~~~~~~~~~~~~~

      
      // popupMsg:false,
      tableSelection: [], // 数据表选择数据集合
      tableSelectObj: {}, // 数据表单条选择数据对象
      // tableSelectKey: '',
      tableLoading: false,
      // phyDate: '',
      // width: '70%',
      // formInline: {// 筛选条件表单数据
      //   cityID: '',
      //   countryID: '',
      //   provinceID: '',
      //   gardenId: '',
      //   childName: '',
      //   sex: '',
      //   mecType: '',
      //   isPushed: '',
      //   isIssued: '',
      //   pageNum: 1,
      //   pageSize: 10
      // },
      // show: {
      //   selCountry: false,
      //   selCity: false
      // },
      // selectpro: [], // 筛选条件下拉框省数据
      // selectcity: [], // 筛选条件下拉框市数据
      // selectarea: [], // 筛选条件下拉框区数据
      // selectGarden: [{orgKindID: '', fullName: '全部'}], // 筛选条件下拉框幼儿园数据
      // currentPage: 1,
      
      // listArea:[]
    }
  },
  methods: {
    //ok~~~~~~~~~~~~~~~~
    operate(row){
      let that=this
      that.$router.push({ path: '/main/edit',query:{id:row.id,specId:row.standardId,childId:row.studentId}})
      that.dialogVisable=true
    },
      send(url,pram,isGet){
        return new Promise(function(resolve) {
          if(isGet){
            ajax.get( url, pram).then(function (data) {
              resolve(data)
            })
          }
          else{
            ajax.post( url, pram).then(function (data) {
              resolve(data)
            })
          }
        })
      },
      getHeader() {// 获取表头
        let that=this
          return new Promise(function(resolve) {

            that.send(config.khsHost +that.$api.getHeads+'?specId='+that.queryForm.specId,{}).then((data)=>{
              that.thData=data.body
              resolve()
            })
            
          })
        },
        getList(){
          let that=this
          return new Promise(function(resolve) {
            let pram=that.queryForm
            if(pram.testDate&&pram.testDate.length>0){
              pram.startDate=pram.testDate[0]
              pram.endDate=pram.testDate[1]
            }
            else{
               pram.startDate=''
               pram.endDate=''
            }
            that.send(config.khsHost +that.$api.getLists,pram).then((data)=>{
              that.tableData=data.body.list
              that.total=data.body.page.total
              resolve()
            })
            
          })
        },
        addPhysique(){
          let that=this
          that.$router.push({ path: '/main/edit' })
          that.dialogVisable=true
        },


    //ok~~~~~~~~~~~~~~~~~~~~~





    handleSizeChange (val) { // 分页每页条数改变事件
      this.queryForm.pageSize = val
      this.getList()
    },
    handleCurrentChange (val) { // 分页页数改变事件
      this.queryForm.pageNum = val
      this.getList()
    },
    GetMonthStr (AddMonthCount) { // 获取过去几个月
      var dd = new Date()
      dd.setMonth(dd.getMonth() - AddMonthCount)// 获取AddMonthCount月后的日期
      var y = dd.getFullYear()
      var m = dd.getMonth() + 1// 获取当前月份的日期
      var d = dd.getDate()
            // 判断 月
      if (m < 10) {
        m = '0' + m
      } else {
        m = m
      }
            // 判断 日n
      if (d < 10) { // 如果天数<10
        d = '0' + d
      } else {
        d = d
      }
      return y + '-' + m + '-' + d
    },
    handleClose () {
      let that = this
      // this.width = '70%'
      that.dialogVisable = false
    },
    close (flag, refresh) {
      let that = this
      // this.width = '70%'
      that.dialogVisable = flag
      if (refresh === true) {
        that.getList()
      }
    },
    getDateN (date) {
      date = (date < 10) ? (date = '0' + date) : date
      return date
    },
    tableSelect (selection, val) { // 表格选中事件
      this.tableSelection = selection
      this.tableSelectObj = val
    },
    tableSelectAll (selection) {
      this.tableSelection = selection
    },
    onSubmit (pram) { // 查询条件查询按钮点击事件
      pram.pageNum = 1
      this.getOrgList(pram)
    },
    getOrgList (pram) { // 获取表格数据
      var that = this
      ajax.post(config.host + 'childMec/getChildMECInfoList.do', pram).then(function (response) {
        that.tableData = response.body.list
        that.total = response.body.page.total
        that.tableSelection = [] // 数据表选择数据集合
        that.tableSelectObj = {} // 数据表单条选择数据对象
      })
    },
    onReset () { // 查询条件重置
      this.$refs['queryForm'].resetFields()
      this.queryForm.testDate = ''
      this.queryForm.childName = ''
    },
    changePhy (val) { // 体检日期的转换
      if (val) {
        var d = new Date(val[0])
        var b = new Date(val[1])
        var startYouWant = d.getFullYear() + '-' + this.getDateN(d.getMonth() + 1) + '-' + this.getDateN(d.getDate())
        var endYouWant = b.getFullYear() + '-' + this.getDateN(b.getMonth() + 1) + '-' + this.getDateN(b.getDate())
        this.queryForm.startDate = startYouWant
        this.queryForm.endDate = endYouWant
      } else {
        this.queryForm.startDate = ''
        this.queryForm.endDate = ''
      }
    },
    detail (row) { // 详情
      // this.width = '70%'
      this.dialogVisable = true
      this.$router.push({path: '/main/detail',query:{id:row.id,specId:row.standardId,childId:row.studentId}})
    },
    showMsgTip (value, type) { // 提示消息
      if (type === 'false') {
        this.$message({
          message: value
        })
      } else {
        this.$message({
          message: value,
          type: type
        })
      }
    },
    doRemove(ids){
      let self=this
      return new Promise((resolve)=>{
          if(ids){
            self.send(config.khsHost +self.$api.deletePecByIDS.replace('{ids}',ids),{},true).then((data)=>{
              if(data.success){
                resolve(true)
              }
              else{
                self.$message.error('删除失败!')
                resolve(false)
              }
            })
          }
          else{
              resolve(true)
          }
      })
    },
    remove (row) { // 删除按钮
      if(row&&row.id){
        this.$confirm('您确定要删除该条体质记录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.doRemove(row.id).then((flag)=>{
            if(flag){
              this.$message.success('已成功删除（1）条体质数据!')
              this.getList()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
      else if (this.tableSelection.length === 0) {
        this.showMsgTip('错误！您没有选择任何数据', 'false')
      } else {
        this.$confirm('您确定要删除所选择的体质记录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let ids=''
          this.tableSelection.forEach((i)=>{
            if (ids === '') {
              ids = i.id
            } else {
              ids += ',' + i.id
            }
          })
          this.doRemove(ids).then((flag)=>{
            if(flag){
              this.$message.success('已成功删除（'+this.tableSelection.length+'）条体质数据!')
              this.getList()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
      
    },
    AddTo () { // 添加
      // this.width = '70%'
      this.dialogVisable = true
      this.$router.push({ path: '/childPhy/add' })
    },
    doClick(operFunc,index,row){
      switch(operFunc){
       case 'doAdd':this.addPhysique();break
       case 'doDelelte':this.remove();break
      }
    }
  },
  created () {
    let that=this
    //ok~~~~~~~~~~~~~~~~~~~
      //1.获取标准列表初始化显示查询条件的标准
      that.send(config.khsHost +that.$api.getStandardList,{},true).then((data)=>{

        //2.判断是否有无标准，如果没有则显示需要进行添加的页面跳转
        if(data.success&&data.body.length>0){
          that.standList=data.body
          //3.如果有标准的话默认读取一个标准
          that.queryForm.specId=data.body[0].id
          //4.如果有标准的话进行表头查询
          that.getHeader()
          //5.根据查询条件查询内容和表头匹配渲染
          that.getList()
        }
        else{
          that.$message.error('无标准数据!')
        }
      })
     
      
      

    //ok~~~~~~~~~~~~~~~~~~~




    // that.getOrgList(that.queryForm)
    // ajax.get(config.host + 'org/getOrgDetail.do').then(function (json) {
    //   if (json.success === true) {
    //     if (json.body.scopeType === 1) { // 当前账号是省级妇保院
    //       that.show.selCity = true
    //       that.show.selCountry = true
    //       that.selectcity = [{id: '', name: '全部'}]
    //       that.selectarea = [{id: '', name: '全部'}]
    //       that.getList('common/getAreasList.do', { 'parentID': json.body.provinceID }, 'selectcity')
    //       // that.getList('common/getAreasList.do', { 'parentID': json.body.cityID }, 'selectarea')
    //       that.getList('orgkind/getOrgKindListByArea.do', {provinceID: json.body.provinceID}, 'selectGarden', true)
    //     } else if (json.body.scopeType === 2) { // 当前账号是市级妇保院
    //       that.show.selCountry = true
    //       that.selectarea = [{id: '', name: '全部'}]
    //       that.getList('common/getAreasList.do', { 'parentID': json.body.cityID }, 'selectarea')
    //       that.getList('orgkind/getOrgKindListByArea.do', {provinceID: json.body.provinceID, cityID: json.body.cityID}, 'selectGarden', true)
    //     } else if (json.body.scopeType === 3) { // 当前账号是区级妇保院/街道级妇保
    //       that.getList('orgkind/getOrgKindListByArea.do', {provinceID: json.body.provinceID, cityID: json.body.cityID, countryID: json.body.countryID}, 'selectGarden', true)
    //     } else if (json.body.scopeType === 4) {
    //       that.getList('orgkind/getOrgKindListByArea.do', {}, 'selectGarden', true)
    //     }
    //   }
    // })
  },
  mounted(){
    let btnList = window.paramFromParent
    btnList = common.getBtnList(btnList)
    this.generalArea = btnList.generalArea
    // this.listArea = btnList.listArea
  }
}
</script>

<style scoped>
.ml15 {
  margin-left: 15px;
}
#tableList .el-table .cell, .el-table th>div{
  padding-left: 0;
  padding-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/physique/physiqueMain.vue?67720af3